import React from 'react'
import {useContext, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import { DataContext } from '../DataProvider/DataProvider'
// import { DataContext } from '../DataProvider/DataProvider'

export default function ProtectedRoute({children, msg, redirect}) {

    const navigate = useNavigate()
const [{user}, dispatch] = useContext(DataContext)
    useEffect(()=>{
if(!user){

    navigate("/auth" , {state:{msg, redirect}});
}
    }, [user]);
  return (
    children
  )
}
